"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUTHENTICATION_ACTIONS = void 0;
var AUTHENTICATION_ACTIONS;

(function (AUTHENTICATION_ACTIONS) {
  AUTHENTICATION_ACTIONS["AUTHENTICATION_TOKEN_SET"] = "@hopin/authentication-provider/token-set";
  AUTHENTICATION_ACTIONS["AUTHENTICATION_TOKEN_LOAD"] = "@hopin/authentication-provider/token-load";
  AUTHENTICATION_ACTIONS["AUTHENTICATION_TOKEN_ERROR"] = "@hopin/authentication-provider/token-error";
  AUTHENTICATION_ACTIONS["LOGIN_URL_SET"] = "@hopin/authentication-provider/login-url-set";
})(AUTHENTICATION_ACTIONS = exports.AUTHENTICATION_ACTIONS || (exports.AUTHENTICATION_ACTIONS = {}));